module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": "Link's logo"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.link
    }
  }, [_vm._t("default", [_vm._v("Site")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f034fee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site.vue
// module id = 131
// module chunks = 2